import type { ChainId_L1 } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';

import { TOKEN_CONFIG_MAP } from './tokenConfig';

export { Token, type TokenConfig, type TokenContext } from './model';
export { TOKEN_CONFIG_MAP, TOKEN_LIST_BY_LAYER } from './tokenConfig';
export {
  getRelatedYbZkToken,
  getRelatedZkToken,
  getTokenAddressByCtx,
  getTokenAddressKey,
  getYbTokenBridgeAddress,
} from './utils';

export const useTokenConfig = (network?: ChainId_L1) => {
  const desiredNetwork = currentWallet.useDesiredNetwork();
  return TOKEN_CONFIG_MAP[network ?? desiredNetwork];
};
